<template>
  <q-banner rounded class="bg-blue-1 text-primary q-mb-md">
    {{ message }}
    <template v-slot:action>
      <q-btn
        v-if="canResumeSelected"
        flat
        color="primary"
        :label="$t('addMedia.resume.resumeSelectedPrimary', { count: summary.remainingFiles })"
        @click="$emit('resume-selected')"
      />
      <q-btn
        v-else-if="!awaitingReselection"
        flat
        color="primary"
        :label="$t('addMedia.resume.resume')"
        @click="$emit('resume')"
      />
      <q-btn
        v-else
        flat
        color="primary"
        disable
        :label="$t('addMedia.resume.resumeSelected')"
      />
      <q-btn
        flat
        color="negative"
        :label="$t('addMedia.resume.discard')"
        @click="$emit('discard')"
      />
    </template>
  </q-banner>
</template>

<script>
export default {
  name: 'UploadRecoveryBanner',
  props: {
    summary: {
      type: Object,
      required: true,
    },
    awaitingReselection: {
      type: Boolean,
      default: false,
    },
    canResumeSelected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    message() {
      if (this.canResumeSelected) {
        return this.$t('addMedia.resume.selectedReadyMessage', {
          remaining: this.summary.remainingFiles,
          total: this.summary.totalFiles,
        });
      }

      if (this.awaitingReselection) {
        return this.$t('addMedia.resume.reselectMessage', {
          remaining: this.summary.remainingFiles,
          total: this.summary.totalFiles,
        });
      }

      return this.$t('addMedia.resume.detectedMessage', {
        confirmed: this.summary.confirmedFiles,
        total: this.summary.totalFiles,
      });
    },
  },
};
</script>
